module.exports = __webpack_public_path__ + "img/blt-arrow06.89456ff0.svg";